/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Desc_PlaceholderInputs */

const en_admin_users_credits_desc_placeholder = /** @type {(inputs: Admin_Users_Credits_Desc_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional reason`)
};

/**
* | output |
* | --- |
* | "Optional reason" |
*
* @param {Admin_Users_Credits_Desc_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_desc_placeholder = /** @type {((inputs?: Admin_Users_Credits_Desc_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Desc_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_credits_desc_placeholder(inputs)
});
export { admin_users_credits_desc_placeholder as "admin.users.credits_desc_placeholder" }